import {ManageView} from '@/layouts'

const SideRouter =   [
  {
    path:'/UserInfo',
    name:'UserInfo',
    component: ManageView,
    meta:{title:'个人信息',role:['user','admin']},
    redirect:'/UserInfo/User',
    children:[
      {
        path: '/UserInfo/User',
        name: 'User',
        component: () => import( '@/views/dashboard/UserInfo/User.vue'),
        meta: { title: '个人信息',role:['user','admin']}
      },
    ]
  },
  {
    path:'/dashboard',
    name:'dashboardPage',
    component: ManageView,
    meta:{title:'工作台',role:['user','admin']},
    redirect:'/dashboard/OrderManage',
    children:[
      {
        path: '/dashboard/OrderManage',
        name: 'OrderManage',
        component: () => import( '@/views/dashboard/Orders/OrderManage.vue'),
        meta: { title: '订单管理',role:['user','admin']}
      },
      {
        path: '/dashboard/DemandManage',
        name: 'DemandManage',
        component: () => import( '@/views/dashboard/Orders/DemandManage.vue'),
        meta: { title: '需求管理',role:['user','admin']}
      },
      {
        path: '/dashboard/BidManage',
        name: 'BidManage',
        component: () => import( '@/views/dashboard/Orders/BidManage.vue'),
        meta: { title: '招标管理',role:['user','admin']}
      }
    ]
  },
  {
    path:'/admin',
    name:'admin',
    component: ManageView,
    meta:{title:'管理员功能',role:['admin']},
    redirect:'/admin/UserManage',
    children:[
      {
        path: '/admin/UserManage',
        name: 'UserManage',
        component: () => import( '@/views/dashboard/Admin/UserManage.vue'),
        meta: { title: '用户管理',role:['admin']}
      },
      {
        path: '/admin/DemandAdmin',
        name: 'DemandAdmin',
        component: () => import( '@/views/dashboard/Admin/DemandAdmin.vue'),
        meta: { title: '需求管理',role:['admin']}
      },
      {
        path: '/admin/Exhibition',
        name: 'Exhibition',
        component: () => import( '@/views/dashboard/Admin/Exhibition.vue'),
        meta: { title: '展会管理',role:['admin']}
      },
      {
        path: '/admin/CreateExhibition',
        name: 'CreateExhibition',
        component: () => import( '@/views/dashboard/Admin/CreateExhibition.vue'),
        meta: { title: '添加展会',role:['admin']}
      },
    ]
  },
  {
    path:'/Factory',
    name:'Factory',
    component: ManageView,
    meta:{title:'工厂管理',role:['user','admin']},
    redirect:'/Factory/MyFactory',
    children:[
      {
        path: '/Factory/MyFactory',
        name: 'MyFactory',
        component: () => import( '@/views/dashboard/Factory/MyFactory.vue'),
        meta: { title: '我的工厂',role:['user','admin']}
      },
      {
        path: '/Factory/CreateFactory',
        name: 'CreateFactory',
        component: () => import( '@/views/dashboard/Factory/CreateFactory.vue'),
        meta: { title: '创建工厂',role:['user','admin']}
      },
      
    ]
  }

]

export default SideRouter